// extracted by mini-css-extract-plugin
export var activityContainer = "_m1-0";
export var typingIndicatorContainer = "_m1-1";
export var typingIndicatorDot = "_m1-2";
export var wave = "_m1-3";